export const integrationConfig = {
  analytics: import.meta.env.VITE_ENABLE_ANALYTICS === "true",
  accessGate: import.meta.env.VITE_ENABLE_ACCESS_GATE === "true",
};

export function isProductionHost() {
  return (
    typeof window !== "undefined" &&
    ["novavp.site", "www.novavp.site"].includes(window.location.hostname)
  );
}

export function analyticsEnabled() {
  return integrationConfig.analytics && isProductionHost();
}
